import { Calculation } from 'final-form-calculate'
import { CondutaOdontoEnum, TipoAtendimentoEnum, TipoConsultaOdontoEnum } from 'graphql/types.generated'
import { isEmpty } from 'lodash'
import { ProcedimentosAutomaticoAtendimentoOdonto, ProcedimentosAutomaticosAtendimentoIndividual } from 'types/enums'
import { ProcedimentosAutomaticos } from 'view/atendimentos/atendimento-individual/AtendimentoIndividualView'
import { meta, SoapState } from 'view/atendimentos/atendimento-individual/model'
import {} from 'view/atendimentos/detail/soap/desfecho/calculator'
import {
  calculateProcedimentosAutomaticosByTipoAtendimento,
  getProcedimentosWithNewProced,
} from 'view/atendimentos/detail/soap/desfecho/calculator/calculatorIndividual'

const tipoConsultaCalculator = (procedimentosAutomaticos: ProcedimentosAutomaticos): Calculation => ({
  field: meta.desfecho.tipoConsulta.absolutePath(),
  updates: {
    [meta.desfecho.condutasOdonto.absolutePath()]: (tipoConsulta: TipoConsultaOdontoEnum, allValues: SoapState) => {
      const tipoConsultaNullOrManutencao = !tipoConsulta || tipoConsulta === 'CONSULTA_DE_MANUTENCAO'
      const condutaToRemove = tipoConsultaNullOrManutencao
        ? CondutaOdontoEnum.TRATAMENTO_CONCLUIDO
        : CondutaOdontoEnum.ALTA_DO_EPISODIO
      return allValues.desfecho.condutasOdonto?.filter((c: CondutaOdontoEnum) => c !== condutaToRemove)
    },
    [meta.desfecho.procedimentosAdministrativos.absolutePath()]: (
      tipoConsulta: TipoConsultaOdontoEnum,
      allValues: SoapState,
      prevValues: SoapState
    ) => {
      if (!isEmpty(prevValues) && tipoConsulta) {
        const procedToAdd =
          tipoConsulta === TipoConsultaOdontoEnum.PRIMEIRA_CONSULTA_ODONTOLOGICA_PROGRAMATICA
            ? ProcedimentosAutomaticoAtendimentoOdonto.PRIMEIRA_CONSULTA_ODONTOLOGICA_PROGRAMATICA
            : ProcedimentosAutomaticosAtendimentoIndividual.CONSULTA_DE_PROFISSIONAIS_DE_NIVEL_SUPERIOR_NA_ATENCAO_BASICA

        const procedRef = procedimentosAutomaticos.find((p) => p.codigo === procedToAdd)
        return getProcedimentosWithNewProced(allValues.desfecho.procedimentosAdministrativos, procedRef)
      }
      return allValues.desfecho.procedimentosAdministrativos
    },
  },
})

const tipoAtendimentoCalculator = (procedimentosAutomaticos: ProcedimentosAutomaticos): Calculation => ({
  field: [meta.desfecho.tipoAtendimento.absolutePath()],
  updates: {
    [meta.desfecho.tipoConsulta.absolutePath()]: (tipoAtendimento: TipoAtendimentoEnum, allValues: SoapState) =>
      tipoAtendimento === TipoAtendimentoEnum.URGENCIA &&
      allValues.desfecho.tipoConsulta === TipoConsultaOdontoEnum.CONSULTA_DE_RETORNO
        ? undefined
        : allValues.desfecho.tipoConsulta,

    [meta.desfecho.procedimentosAdministrativos.absolutePath()]: (
      tipoAtendimento: TipoAtendimentoEnum,
      allValues: SoapState,
      prevValues: SoapState
    ) => {
      if (!isEmpty(prevValues)) {
        return allValues.desfecho.tipoConsulta === TipoConsultaOdontoEnum.PRIMEIRA_CONSULTA_ODONTOLOGICA_PROGRAMATICA
          ? allValues.desfecho.procedimentosAdministrativos
          : calculateProcedimentosAutomaticosByTipoAtendimento(allValues, false, procedimentosAutomaticos)
      }
      return allValues.desfecho.procedimentosAdministrativos
    },
  },
})

export const createDesfechoOdontoCalculations = (procedimentosAutomaticos: ProcedimentosAutomaticos): Calculation[] => [
  tipoConsultaCalculator(procedimentosAutomaticos),
  tipoAtendimentoCalculator(procedimentosAutomaticos),
]
